import React from "react";
import { Collapse, Tag, Space, Typography } from "antd";
import { decodeStr } from "../../../utils";
import CompanyHeader from "./CompanyHeader";
import CompanyOfficesTable from "./CompanyOfficesTable";
import CompanyMiniMap from "./CompanyMiniMap";
import config from "../../../api_config.json";
import ParseLogo from "../../shared/images/parse.png";
import { useAppContext } from "../../../context";

const { Text } = Typography;

const CompanySection = ({ company, offices, coords }) => {
  const { isProd } = useAppContext();
  const env = isProd ? "prod" : "dev";
  const activeOffices = offices.filter((o) => o.enabled).length;
  const totalOffices = offices.length;

  const panelHeader = (
    <div className="company-section-header">
      <Text
        strong
        style={{
          fontSize: 16,
          color: company.enabled ? "green" : "red",
        }}
      >
        {decodeStr(company.nome || "Azienda senza nome")}
      </Text>
      {company.nascondi && <Tag color="orange" style={{ marginLeft: 8 }}>Nascosta</Tag>}
      <div className="company-section-right">
        <Space align="center" size={8}>
          <Tag color="green">{activeOffices} attive</Tag>
          <Tag color="red">{totalOffices - activeOffices} disattive</Tag>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`${config.parseDashboard[env]}/browser/company?filters=[{"field":"objectId","constraint":"eq","compareTo":"${company.objectId}"}]`}
            onClick={(e) => e.stopPropagation()}
          >
            <img src={ParseLogo} width={16} alt="Parse" />
          </a>
        </Space>
      </div>
    </div>
  );

  return (
    <Collapse
      className="company-section"
      defaultActiveKey={[]}
      style={{ marginBottom: 16 }}
    >
      <Collapse.Panel header={panelHeader} key="company">
        <CompanyHeader company={company} />
        <div style={{ marginTop: 16 }}>
          <CompanyOfficesTable offices={offices} />
        </div>
        <CompanyMiniMap coords={coords} companyName={company.nome} />
      </Collapse.Panel>
    </Collapse>
  );
};

export default CompanySection;
